/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class MapConfigurationModel {
        public mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public gisDatastores: Wars.Domain.Model.Gis.GisDatastore[];
        private systemLevelId: string;

        public showMapConfiguration: boolean=true;
        public showLayerConfiguration: boolean = false;
        public showLegendConfiguration: boolean = false;
        public showMapFunctionConfiguration: boolean = false;
        public showGisActionWorkflowConfiguration: boolean=false;
        public showPreview: boolean=false;
        public showEsriQueries: boolean=false;
        public showGisDatastoreQueries: boolean=false;
        public showQueryGridConfiguration:boolean=false;
        public showJavascriptTransformers:boolean=false;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private gisDataStoreService: services.GisDatastoreService,
            private mapConfigurationId: string) {

            this.mapConfigurationService.getMapConfiguration(mapConfigurationId).then(r => {
                this.mapConfiguration = r;
            });

            gisDataStoreService.getGisDatastores().then(g => {
                this.gisDatastores = g;
            });
        }

        public showSection(sectionName: string) {
            this.showMapConfiguration = false;
            this.showLayerConfiguration = false;
            this.showLegendConfiguration = false;
            this.showMapFunctionConfiguration = false;
            this.showGisDatastoreQueries = false;
            this.showGisActionWorkflowConfiguration = false;
            this.showQueryGridConfiguration = false;
            this.showPreview = false;
            this.showEsriQueries= false;
            this.showJavascriptTransformers= false;

            switch (sectionName) {
            case "JavascriptTransformers":
                this.showJavascriptTransformers = true;
                break;
            case "MapConfiguration":
                this.showMapConfiguration = true;
                break;
            case "Layers":
                this.showLayerConfiguration = true;
                break;
            case "Legends":
                this.showLegendConfiguration = true;
                break;
            case "GisDatastoreQueries":
                this.showGisDatastoreQueries = true;
                break;
            case "MapFunctions":
                this.showMapFunctionConfiguration = true;
                break;
            case "GisActionWorkflow":
                this.showGisActionWorkflowConfiguration = true;
                break;
            case "EsriQueries":
                this.showEsriQueries = true;
                break;
            case "Preview":
                this.showPreview = true;
                break;
            case "QueryGrids":
                this.showQueryGridConfiguration = true;
                break;
            default:
            }
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }
    }
}